import React from 'react';
import Form from '@rjsf/core';
import { noop } from 'rxjs';
import { formatCurrencyInput } from '../../utils/helpers';
import { defaultValidator } from '../../utils/json-schema-validator/validator';

/*
// ATTRIBUTES SCHEMA = Object
// {
//   'field1': {
//     'type': 'string',
//     'title': 'Field 1'
//   },
//   'field2': {
//     'type': 'string',
//     'title': 'Field 2'
//   },
//   ...,
//   'amount': {
//     'type': number,
//     'title': 'Payment Amount',
//     'default': defaultAmount
//   }
// }
//
 */
export const DynamicLookupFieldGroup = ({
  attributes,
  attributesGroupName,
  requiredFields,
  submitForm = noop,
  formActions,
  onChange,
  formData,
}) => {
  if (attributes.amount) {
    attributes.amount.default = formatCurrencyInput(
      attributes.amount?.default ?? 0,
    );
  }
  const jsonSchema = {
    title: attributesGroupName,
    type: 'object',
    required: requiredFields,
    properties: attributes,
  };

  const uiSchema = Object.entries(attributes).reduce((acc, cur) => {
    const [key, form_field_attributes] = cur;
    /*
      The backend has data on whether or not quantity and price (amount) are editable.
      To avoid needing to add a new field to this file every time the backend has the ability to make the field editable or disabled,
      we can dynamically generate a structure like the one below:
      {
        amount: {
          'ui:disabled': Boolean,
        },
        quantity: {
          'ui:disabled': Boolean,
        },
      };
    */
    if (form_field_attributes.hasOwnProperty('editable')) {
      const isFieldEditable = form_field_attributes.editable;
      acc[key] = {
        'ui:disabled': !isFieldEditable,
      };
    }
    if (key === 'quantity' && !form_field_attributes.editable) {
      acc[key] = {
        'ui:widget': 'hidden',
      };
    }
    return acc;
  }, {});

  const handleSubmit = ({ formData }) => {
    // Might need to format here
    submitForm(formData);
  };

  return (
    <Form
      schema={jsonSchema}
      uiSchema={uiSchema}
      validator={defaultValidator}
      onSubmit={handleSubmit}
      onChange={onChange}
      formData={formData}
    >
      {formActions}
    </Form>
  );
};
